import React from "react";

/**
 * Compact, metadata-driven market-data context. It avoids suggesting that
 * development/sandbox data is live or licensed production data.
 */
export function DataSourceBadge({ metadata, className = "" }) {
  if (!metadata) return null;

  const label =
    metadata.mode === "development"
      ? "DEVELOPMENT DATA"
      : metadata.mode === "production"
        ? "MARKET DATA"
        : "ILLUSTRATIVE DATA";

  return (
    <span
      data-testid="market-data-source-badge"
      className={
        "inline-flex items-center rounded-full border border-indigo-400/20 bg-indigo-400/10 px-2.5 py-1 text-[10px] font-semibold tracking-[0.12em] text-indigo-200 " +
        className
      }
    >
      {label}
    </span>
  );
}
